import React from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from '../../Components/PageTitle/PageTitle.jsx'

export default function Contacts() {
    return (
        <div>
            <Helmet>
                <title>Contact Hossam</title>
            </Helmet>
            <PageTitle title="Contacts" />
            
        </div>
    )
}
